export const TEXTS = {
    QTY: "qty",
};
